import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DataCoreService,
  DlistDto,
  DlistFieldDto,
  environment,
  FormDto,
  GetDlist_Request,
  GetDlist_Response,
  GetFormMetadata_Request,
  GetGorevSayac_Request,
  OrtakService,
  SetBildirimOkundu_Request,
  SetBildirimOkundu_Response,
} from '@dabnet-kamu/libs/ui';
import {
  BehaviorSubject,
  catchError,
  finalize,
  map,
  Observable,
  tap,
  throwError,
} from 'rxjs';
import { JsonApiClient } from '@servicestack/client';

@Injectable({
  providedIn: 'root',
})
export class GenBildirimService {
  formMetaData$: Observable<FormDto>;

  //GenBildirim
  private _gridCtlGenBildirim: BehaviorSubject<DlistDto | null> =
    new BehaviorSubject(null);
  public gridCtlGenBildirim$ = this._gridCtlGenBildirim.asObservable();

  private _fieldsGenBildirim: BehaviorSubject<DlistFieldDto[] | null> =
    new BehaviorSubject(null);
  public fieldsGenBildirim$ = this._fieldsGenBildirim.asObservable();

  private _genBildirimForm: BehaviorSubject<FormDto | null> =
    new BehaviorSubject(null);
  public genBildirimMetadata$ = this._genBildirimForm.asObservable();


  
  private _gridCtlTelefon: BehaviorSubject<DlistDto | null> =
    new BehaviorSubject(null);
  public gridCtlTelefon$ = this._gridCtlTelefon.asObservable();

  private _gridCtlPersonel: BehaviorSubject<DlistDto | null> =
    new BehaviorSubject(null);
  public gridCtlPersonel$ = this._gridCtlPersonel.asObservable();

  private _gridCtlGenDuyuru: BehaviorSubject<DlistDto | null> =
    new BehaviorSubject(null);
  public gridCtlGenDuyuru$ = this._gridCtlGenDuyuru.asObservable();


  
  errorResponse: any = {};

  constructor(
    private dataCoreService: DataCoreService,
    private _httpClient: HttpClient,
    private ortakService: OrtakService
  ) {}

  getGenBildirimData() {
    const dataSource = this.dataCoreService.getOData('GenBildirim');
    dataSource.sort([{ selector: 'KayitTarih', desc: true }]);
    return dataSource;
  }

  getDlist(formName: string): any {
    const request = new GetDlist_Request({
      dListCode: formName,
    });
    this._httpClient
      .post<GetDlist_Response>(
        `${environment.ortakService}/System/GetDList`,
        request
      )
      .pipe(
        tap((response) => {
          if (formName === 'GenBildirim') {
            this._gridCtlGenBildirim.next(response.dListMetadata);
            this._fieldsGenBildirim.next(response.dListMetadata.fields);
          }
           if (formName === 'vBimPersonelTelefon') {
            this._gridCtlTelefon.next(response.dListMetadata);
          }
          if (formName === 'vIkaIzinliPersonelList') {
            this._gridCtlPersonel.next(response.dListMetadata);
          }
          if( formName === 'GenDuyuru') {
            this._gridCtlGenDuyuru.next(response.dListMetadata);
          }
        }),
        catchError((err) => throwError(err)),
        finalize(() => {})
      )
      .subscribe();
  }

  removeGenBildirim(data: any): Promise<any> {
    return this.dataCoreService.removeDataStore('GenBildirim', data);
  }

  client = JsonApiClient.create(environment.ortakService);

  async bildirimRequest(request?: any): Promise<any> {
    var newRequest = {
      bildirimKod: request?.Kod || null,
      silEh: request?.silEH,
      tumuEh: request?.TumuEH,
    };
    return await this.client.api(new SetBildirimOkundu_Request(newRequest));
  }

  getFormMetaData(formData: GetFormMetadata_Request) {
    const request = new GetFormMetadata_Request({
      formAd: formData.formAd!,
      altFormAd: formData.altFormAd || '',
      kod: formData.kod || 0,
      logYn: formData.logYn || false,
    });
    this.ortakService
      .getFormMetadata(request)
      .pipe(
        tap((response) => {
          this._genBildirimForm.next(response.formMetadata);
        })
      )
      .subscribe();
  }
    getData(tableName:string,groupedColumnName:string,filter?:any) {
    const dataSource = this.dataCoreService.getOData(tableName,null,null,"Kod",null,false);
    dataSource.select([]);
    dataSource.group(groupedColumnName);
    if (filter) {
      dataSource.filter(filter);
    }
    return dataSource;
  }


}
